<template>
  <div class="text-xs-center">
    <div v-if="index != 0 && showForward" class="pb-2">
      <a href="javascript:void(0)" @click="$emit('onMove', 'top')">
        <span class="fas fa-angle-double-up"></span>
      </a>
    </div>
    <div v-if="index > 0" class="pb-2">
      <a href="javascript:void(0)" @click="$emit('onMove', 'up')">
        <span class="fas fa-angle-up"></span>
      </a>
    </div>
    <div v-if="index < lastIndex" class="pb-2">
      <a href="javascript:void(0)" @click="$emit('onMove', 'down')">
        <span class="fas fa-angle-down"></span>
      </a>
    </div>
    <div v-if="index != lastIndex && showForward" class="pb-2">
      <a href="javascript:void(0)" @click="$emit('onMove', 'bottom')">
        <span class="fas fa-angle-double-down"></span>
      </a>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ['index', 'max', 'showForward'],
  computed: {
    lastIndex: function () {
      return this.max - 1
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/elements/MoveVertical.vue